import { Component, OnInit } from '@angular/core';

import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';
import { TranslatePipe } from '@pipes/translate.pipe';
import { UiHelper } from '@helpers/ui.helper';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'deposit-limit-dialog',
  templateUrl: '../sharedTemplates/deposit-limit.dialog.html',
})
export class DepositLimitDialog implements OnInit {
  DepositMonthlyLimitModel = 1000;
  selfLimit: any;
  password: any;
  todayShortFormat: string;
  depositMonthlyNow: any;
  days = 7; // For Plus activate Days
  oldSelfLimitData: any;
  now = new Date();
  today = new Date();
  nowShortFormat: any;
  buttonState = true;
  selfLimitsData: UntypedFormGroup;

  constructor(
    private _ApiService: ApiService,
    public _LocalizationService: LocalizationService,
    public _UserHelper: UserHelper,
    private _router: Router,
    private _UiHelper: UiHelper,
    public dialogRef: MatDialogRef<DepositLimitDialog>,
    private _FormBuilder: UntypedFormBuilder
  ) {
    this.selfLimitsData = _FormBuilder.group({
      DepositMonthlyLimitModel: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(1), Validators.max(30000)]),
      activityCode: new UntypedFormControl({ value: '', disabled: false }, []),
    });
  }

  ngOnInit() {
    this.addDays();
  }

  ngAfterViewInit() {
    this.getSelfLimits();
  }

  addDays() {
    this.now.setDate(this.now.getDate() + this.days);

    this.nowShortFormat = this.now.toLocaleDateString();

    this.today.setDate(this.today.getDate() + 0);

    this.todayShortFormat = this.today.toLocaleDateString();
  }

  DepositMonthlyLimitionChange(e) {
    if (e < this.oldSelfLimitData.DepositMonthlyLimit) {
      this.depositMonthlyNow = this.todayShortFormat;
    } else {
      this.addDays();
      this.now.setDate(this.now.getDate() - this.days);

      this.depositMonthlyNow = this.now.toLocaleDateString();
    }
  }
  getSelfLimits() {
    this._ApiService.getSelfLimits().then(x => {
      this.selfLimit = x[0];

      this.DepositMonthlyLimitModel = this.selfLimit.DepositMonthlyLimit;
      this.selfLimitsData.controls.DepositMonthlyLimitModel.setValue(1000);
      this.selfLimitsData.controls.activityCode.setValue(5);
    });
  }
  saveSelfLimitsDataPassword() {
    if (this.buttonState) {
      this.selfLimit.DepositMonthlyLimit = this.selfLimitsData.value.DepositMonthlyLimitModel;
      this.selfLimit.password = this.selfLimitsData.value.password;
      this.selfLimit.activityCode = this.selfLimitsData.value.activityCode;
      this.buttonState = false;

      const translator = new TranslatePipe(this._LocalizationService);

      this._ApiService
        .saveSelfLimitsWithPassword(this.selfLimit)
        .then(result => {
          this._UiHelper.setLoadingDialog(true);
          if (result.code == '') {
            const t_message = translator.transform(result.message, null);

            this._UiHelper.errorSnackBar(t_message, '');
          } else {
            if (result.code == 'error') {
              // let t_message = translator.transform(result.message, null);

              this._UiHelper.errorSnackBar(result.message, '');
            } else if (result.code == 'errorcode') {
              const t_message = translator.transform(result.message, null);

              this._UiHelper.errorSnackBar(t_message, '');
            } else if (result.code == 'success') {
              const t_message = translator.transform(result.message, null);
              this._UiHelper.successSnackBar(t_message, '');
              this.dialogRef.close();

              this._router.navigate(['/sports']).then();
            }
          }
        })
        .finally(() => {
          setTimeout(() => (this.buttonState = true), 1000);
          this._UiHelper.setLoadingDialog(false);
        });
    }
  }
  saveSelfLimitsData() {
    if (this.buttonState) {
      this.selfLimit.DepositMonthlyLimit = this.selfLimitsData.value.DepositMonthlyLimitModel;
      this.selfLimit.activityCode = this.selfLimitsData.value.activityCode;
      this.buttonState = false;

      const translator = new TranslatePipe(this._LocalizationService);

      this._ApiService
        .saveSelfLimits(this.selfLimit)
        .then(result => {
          this._UiHelper.setLoadingDialog(true);
          if (result.code == '') {
            const t_message = translator.transform(result.message, null);

            this._UiHelper.errorSnackBar(t_message, '');
          } else {
            if (result.code == 'error') {
              // let t_message = translator.transform(result.message, null);

              this._UiHelper.errorSnackBar(result.message, '');
            } else if (result.code == 'errorcode') {
              const t_message = translator.transform(result.message, null);

              this._UiHelper.errorSnackBar(t_message, '');
            } else if (result.code == 'success') {
              const t_message = translator.transform(result.message, null);
              this._UiHelper.successSnackBar(t_message, '');
              this.dialogRef.close();

              this._router.navigate(['/sports']).then();
            }
          }
        })
        .finally(() => {
          setTimeout(() => (this.buttonState = true), 1000);
          this._UiHelper.setLoadingDialog(false);
        });
    }
  }
}
